<template>
  <div class="block-loader" role="status" aria-live="polite">
    <div class="block-loader__inner">
      <span class="spinner" />
      <p>{{  $t('DASHBOARD.LOADING') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockLoader',
};
</script>

<style scoped>
.block-loader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.block-loader__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}
.block-loader__inner p {
  margin: 0;
  font-weight: 500;
  color: var(--s-600, #333);
}
</style>
